import { render, staticRenderFns } from "./order-title.vue?vue&type=template&id=951a5c0a&scoped=true&"
import script from "./order-title.vue?vue&type=script&lang=js&"
export * from "./order-title.vue?vue&type=script&lang=js&"
import style0 from "./order-title.vue?vue&type=style&index=0&id=951a5c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a5c0a",
  null
  
)

export default component.exports